import React, { useContext } from 'react'
import { Link, useNavigate, useLocation } from 'react-router-dom'
// import { SubmitHandler, useForm } from "react-hook-form";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import Swal from 'sweetalert2'
import JWTContext from '../../context/JWTContext';

import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";

import { DEFAULT_COUNTRY_CODE } from "../../constants";

const schema = yup.object({
    // username: yup.string().required(),
    username: yup.string().notRequired(),
    phoneNumber: yup.string().required(),
    email: yup.string().email().required(),
    password: yup.string().required().min(8, "Password too short")
        .test("isValidPass", "Password must be 8 char (one uppercase & one symbol & one number)", (value, context) => {
            const hasUpperCase = /[A-Z]/.test(value);
            const hasLowerCase = /[a-z]/.test(value);
            const hasNumber = /[0-9]/.test(value);
            const hasSymbole = /[!@#%&]/.test(value);
            let validConditions = 0;
            const numberOfMustBeValidConditions = 3;
            const conditions = [hasLowerCase, hasUpperCase, hasNumber, hasSymbole];
            conditions.forEach((condition) =>
                condition ? validConditions++ : null
            );
            if (validConditions >= numberOfMustBeValidConditions) {
                return true;
            }
            return false;
        }),
    //   name:yup.string().required(),
    companyName: yup.string().notRequired(),
    confirmPassword: yup.string().required().oneOf([yup.ref('password')], 'Must match with "Password"'),
    dateOfBirth: yup.date().required("Date of birth is required")
}).required();

const RegisterForm = () => {
    const navigate = useNavigate();
    const [isShowPassword, setIsShowPassword] = React.useState(false);
    const [isShowConfirmPassword, setIsShowConfirmPassword] = React.useState(false);
    const [isCheckedAccept, setIsCheckedAccept] = React.useState(false);

    const location = useLocation();

    const params = new URLSearchParams(location.search);
    const redirectPath = params.get('redirect') || '/';

    const { register: registerAccount } = useContext(JWTContext);

    // const {
    //     register,
    //     handleSubmit,
    //     formState: { errors }
    // } = useForm({
    //     resolver: yupResolver(schema)
    //     , defaultValues: {
    //         phoneCC: "+62"
    //     }
    // });

    const {
        control,
        register,
        handleSubmit,
        formState: { errors },
    } = useForm({
        resolver: yupResolver(schema),
        defaultValues: {
            phoneNumber: "",
        },
    });

    const onSubmit = async (data) => {
        if (isCheckedAccept) {
            // console.log('🟢 Form submitted:', data);
            try {
                const result = await registerAccount({
                    // username: data.username,
                    // phoneNumber:data.phoneNumber,
                    // email: data.email,
                    // password: data.password,
                    // confirmPassword: data.confirmPassword,
                    // name:data.name,
                    // companyName:data.companyName,
                    // birthDate:data.dateOfBirth
                    email: data.email,
                    fullName: data.username, //pake field username aja buat fullname
                    companyName: data.companyName,
                    password: data.password,
                    phoneNumber: data.phoneNumber,
                    confirmPassword: data.confirmPassword,
                    birthDate: data.dateOfBirth
                });
                //console.log(result);
                Swal.fire({
                    title: "Success",
                    text: "Register successfully",
                    icon: "success"
                });
                navigate(`/login?redirect=${encodeURIComponent(redirectPath)}`);
            } catch (err) {
                //console.log(err);
                Swal.fire({
                    title: "Error",
                    text: err,
                    icon: "error"
                });
            }
        } else if (data.password !== data.confirmPassword) {
            Swal.fire({
                title: "Error",
                text: "Password and Confirm Password do not match.",
                icon: "error"
            });
        } else {
            Swal.fire({
                title: "Error",
                text: "Please accept the terms and conditions.",
                icon: "error"
            });
        }
    };

    return (
        <section className='d-flex position-relative align-items-center py-4 bg-main-one-600 h-100' style={{ minHeight: '100vh' }}>
            <img
                src="assets/images/shape/offer-shape.png"
                alt=""
                className="position-absolute inset-block-start-0 inset-inline-start-0 w-100 h-100 opacity-6"
            />
            <div className='authFormRegister'>
                <div className='d-flex justify-content-center mb-48'>
                    <a href="/">
                        {/* <img
                            src='assets/images/logo/logo-iWant-Asia.png' // harusnya putih
                            alt='Logo'
                            className="formLogo"
                            style={{filter: "brightness(0) invert(1)"}}
                        /> */}
                        <span className='text-white text-36'>i WANT Customer Register</span>
                    </a>
                </div>

                <form onSubmit={handleSubmit(onSubmit)} className="border border-white-100 bg-white transition-1 rounded-16 px-24 py-40 h-100">
                    <h6 className="text-3xl text-center text-main-one-600 mb-32">Register</h6>
                    <div className='row mb-12'>
                        <div className="d-none col-12 col-lg-6 mb-12">
                            <input
                                type="text"
                                className="common-input"
                                {...register('name')}
                                placeholder="Enter Your Name"
                            />
                            {errors.name && <span className="text-danger text-sm text-capitalize">{errors.name.message}</span>}
                        </div>
                        <div className="col-12 col-lg-6 mb-12 position-relative">
                            <label style={{
                                position: "absolute",
                                top: "-10px",
                                left: "20px",
                                background: "#fff"
                            }}>
                                <span>Company Name</span>
                            </label>
                            <input
                                type="text"
                                className="common-input"
                                {...register('companyName')}
                                placeholder="Enter Company Name"
                            />
                            {errors.companyName && <span className="text-danger text-sm text-capitalize">{errors.companyName.message}</span>}
                        </div>
                        <div className="col-12 col-lg-6 mb-12 position-relative">
                            <label style={{
                                position: "absolute",
                                top: "-10px",
                                left: "20px",
                                background: "#fff"
                            }}>
                                <span>Full Name</span>
                            </label>
                            <input
                                type="text"
                                className="common-input"
                                {...register('username')}
                                // placeholder="Enter a Username"
                                placeholder="Enter your fullname"
                            />
                            {errors.username && <span className="text-danger text-sm text-capitalize">{errors.username.message}</span>}
                        </div>
                        <div className="col-12 col-lg-6 mb-12 position-relative">
                            <label style={{
                                position: "absolute",
                                top: "-10px",
                                left: "20px",
                                background: "#fff"
                            }}>
                                <span>Email</span>
                            </label>
                            <input
                                type="email"
                                className="common-input"
                                {...register('email')}
                                placeholder="Enter Email Address"
                            />
                            {errors.email && <span className="text-danger text-sm text-capitalize">{errors.email.message}</span>}
                        </div>
                        <div className="col-12 col-lg-6 mb-12 position-relative">
                            <label style={{
                                position: "absolute",
                                top: "-10px",
                                left: "20px",
                                background: "#fff"
                            }}>
                                <span>Date of Birth</span>
                            </label>
                            <input
                                type="text"
                                placeholder="mm/dd/yyyy"
                                className="common-input"
                                {...register('dateOfBirth', {
                                    onBlur: (e) => {
                                        if (!e.target.value) {
                                            e.target.type = 'text';
                                        }
                                    }
                                })}
                                onFocus={(e) => (e.target.type = 'date')}
                                onClick={(e) => (e.target.type = 'date')}
                                onTouchStart={(e) =>
                                    (e.target.type = 'date')
                                }
                                style={{
                                    display: 'block',
                                    width: '100%',
                                    WebkitAppearance: 'none',
                                    appearance: 'none',
                                    textAlign: 'left',
                                    minHeight: '48px'
                                }}
                            />
                            {errors.dateOfBirth && <span className="text-danger text-sm text-capitalize">{errors.dateOfBirth.message}</span>}
                        </div>
                    </div>
                    <div className='row mb-12'>
                        {/* <div className="col-12 col-lg-6 mb-12">
                            <input
                                type="text"
                                className="common-input"
                                id="homenumber"
                                placeholder="Enter a Home Number"
                            />
                        </div> */}
                        <div className="col-12 col-lg-12 mb-12 position-relative">
                            <label style={{
                                position: "absolute",
                                top: "-10px",
                                left: "20px",
                                background: "#fff"
                            }}>
                            <span>Phone Number</span>
                            </label>
                            {/* <div className="d-flex align-items-center common-input py-0">
                                <select className="form-control border-0 p-10 shadow-none  text-14" style={{width:"fit-content"}} {...register("phoneCC")} >
                                    <option defaultValue="+62" value={"+62"}>+62</option>
                                </select> 

                                 <input
                                    type="text"
                                    className="common-input border-0"
                                    {...register('phoneNumber')}
                                    placeholder="Enter a Phone Number"
                                /> 
                            </div>
                            
                            {errors.phoneNumber && <span className="text-danger text-sm text-capitalize">{errors.phoneNumber.message}</span>} */}
                            <Controller
                                name="phoneNumber"
                                control={control}
                                rules={{ required: true }}
                                render={({ field }) => (
                                    <PhoneInput
                                        {...field}
                                        defaultCountry={DEFAULT_COUNTRY_CODE}
                                        international
                                        placeholder="Enter phone number"
                                        className="form-control"
                                    />
                                )}
                            />

                            {errors.phoneNumber && (
                                <span className="text-danger text-sm">
                                    {errors.phoneNumber.message}
                                </span>
                            )}
                        </div>
                    </div>
                    <div className='row'>
                        <div className="col-12 col-lg-6 mb-12 position-relative">
                            <label style={{
                                position: "absolute",
                                top: "-10px",
                                left: "20px",
                                background: "#fff",
                                zIndex:"1"
                            }}>
                            <span>Password</span>
                            </label>
                            <div className="position-relative">
                                <input
                                    type={isShowPassword ? 'text' : 'password'}
                                    className="inputPassword"
                                    {...register('password')}
                                    placeholder="Enter Password"
                                //defaultValue="password"
                                />
                                <span
                                    className={`toggle-password position-absolute top-50 inset-inline-end-0 me-16 translate-middle-y cursor-pointer ph ${isShowPassword ? 'ph-eye' : 'ph-eye-slash'}`}
                                    onClick={() => setIsShowPassword(!isShowPassword)}
                                />
                            </div>
                            {errors.password && <span className="text-danger text-sm text-capitalize">{errors.password.message}</span>}
                        </div>
                        <div className="col-12 col-lg-6 mb-12 position-relative">
                            <label style={{
                                position: "absolute",
                                top: "-10px",
                                left: "20px",
                                background: "#fff",
                                zIndex:"1"
                            }}>
                            <span>Confirm Password</span>
                            </label>
                            <div className="position-relative">
                                <input
                                    type={isShowConfirmPassword ? 'text' : 'password'}
                                    className="inputPassword"
                                    {...register('confirmPassword')}
                                    placeholder="Enter Confirm Password"
                                // defaultValue="password"
                                />
                                <span
                                    className={`toggle-password position-absolute top-50 inset-inline-end-0 me-16 translate-middle-y cursor-pointer ph ${isShowConfirmPassword ? 'ph-eye' : 'ph-eye-slash'}`}
                                    onClick={() => setIsShowConfirmPassword(!isShowConfirmPassword)}
                                />
                            </div>
                            {errors.confirmPassword && <span className="text-danger text-sm text-capitalize">{errors.confirmPassword.message}</span>}
                        </div>
                    </div>
                    <div className="mb-24">
                        <div className="form-check common-check">
                            <input
                                className="form-check-input"
                                type="checkbox"
                                defaultValue={isCheckedAccept}
                                onChange={() => setIsCheckedAccept(!isCheckedAccept)}
                                id="remember"
                            />
                            <label
                                className="form-check-label flex-grow-1"
                                htmlFor="remember"
                                style={{ fontSize: '12px' }}
                            >
                                By clicking 'Agree & Continue', I agree to the <Link target="_blank" rel="noopener noreferrer" className="text-main-one-600 ms-5 text-decoration-underline" to='/term-and-condition'>Terms of Use</Link>,and <Link target="_blank" rel="noopener noreferrer" className="text-main-one-600 ms-5 text-decoration-underline" to="/payment-policy">Privacy Policy</Link> of iWANT-ASIA.com.I agree to receive more information about the platform’s products and services.
                                {/* <Link to="#" className="text-main-one-600 ms-5 text-decoration-underline">
                                    terms & conditions
                                </Link> */}
                            </label>
                        </div>
                    </div>
                    <div className="mt-48">
                        <div className="flex-align gap-48 flex-wrap mb-24">
                            <button type="submit" className="btn btn-main-one w-100 rounded-pill py-15 px-40">
                                Agree & Continue
                            </button>
                        </div>
                        {/* <div className="flex-align gap-48 flex-wrap mb-20">
                            <h4 className='text-center w-100 text-sm fw-medium'>or continue with</h4>
                        </div>
                        <div className="flex-align gap-48 flex-wrap mb-24">
                            <button type="submit" className="btn btn-white border border-main-one-600 hover-border-main-one-600 w-100 rounded-pill py-12 px-40">
                                <img
                                    src='assets/images/social/google.png'
                                    alt='Logo'
                                    className="w-20 h-20"
                                />
                            </button>
                        </div> */}
                        <div className="flex-align flex-wrap">
                            <h4 className='text-center w-100 text-sm fw-medium'>Already have an account? <Link to={`/login?redirect=${encodeURIComponent(redirectPath)}`} className='text-main-one-600'>Login</Link></h4>
                        </div>
                    </div>

                </form>
            </div>
        </section>
    )
}

export default RegisterForm